import { ToastStateHandler, UserApi } from '../../../api';
import { ICallback } from '../../../commonTypes/hook.types';
import { ChangeUserRoleDto } from '../../../commonTypes/user.types';
import { useContainer } from '../../../hooks/useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpPatchUserRole = () => {
    const { t } = useTranslation('newNotifications');
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);

    const execPatch = (body: ChangeUserRoleDto, callback: ICallback) => {
        const { exec, clearCache, abort } = userApi.changeUserRole({
            body,
            onSuccess: () => {
                toastHandler.push('success', t('user.updateRoleTitle'), t('user.updateRoleSuccess'));
                if (callback.onSuccess) callback.onSuccess();
                clearCache();
            },
            onError: () => toastHandler.push('error', t('user.updateRoleTitle'), t('user.updateRoleError')),
        });
        exec();
        return abort;
    };

    return {
        execPatch,
    };
};

export default useHttpPatchUserRole;
